<ng-container *ngIf="badgesAchieved$ | async as badgesAchieved">
  <div class="container badge-achieved" *ngIf="badgesAchieved?.length > 0">
    <div
      class="badge-achieved-container"
      data-bs-toggle="offcanvas"
      data-bs-target="#allBadgesAchieved"
      aria-controls="allBadgesAchieved"
      [ngClass]="{ 'show-badges': showBannerBadges }"
    >
      <div class="mobile-display">
        <h5 class="badge-achieved-title">
          <ng-container *ngTemplateOutlet="badgeCompletedNumber"></ng-container>
          <ng-container *ngTemplateOutlet="title"></ng-container>
        </h5>
        <div class="d-lg-none">
          <ng-container *ngTemplateOutlet="showAll"></ng-container>
        </div>
      </div>

      <div
        class="badge-achieved-content"
        [ngClass]="badgesAchieved.length >= 3 ? 'justify-content-between' : 'justify-content-around'"
      >
        <ng-container *ngIf="showBannerBadges">
          <ng-container *ngFor="let badgeAchieved of badgesAchieved">
            <div class="badge-achieved-item">
              <fgbcl-badge-list-item [badge]="badgeAchieved" [isShowName]="false" />
            </div>
          </ng-container>
        </ng-container>
        <div class="d-none d-lg-flex">
          <ng-container *ngTemplateOutlet="showAll"></ng-container>
        </div>
      </div>
    </div>

    <div class="offcanvas offcanvas-bottom all-badges-achieved-offcanvas" tabindex="-1" id="allBadgesAchieved">
      <div class="icon-close material-icons cursor-pointer text-white" data-bs-dismiss="offcanvas" aria-label="Close">cancel</div>
      <div class="offcanvas-header d-flex justify-content-between align-items-center">
        <h5 class="badge-achieved-title badge-achieved-modal-title">
          <ng-container *ngTemplateOutlet="title"></ng-container>
          (<ng-container *ngTemplateOutlet="badgeCompletedNumber"></ng-container>)
        </h5>
      </div>
      <div class="offcanvas-body">
        <fgbcl-badge-overview-list [showEarnedBadgesOnly]="showEarnedBadgesOnly" />
      </div>
    </div>

    <ng-template #badgeCompletedNumber>
      <span class="badge-completed-number">{{ numberOfCompleted$ | async }}</span>
    </ng-template>

    <ng-template #title>
      <span class="title">{{ 'badge.achieved.title' | translate }}</span>
    </ng-template>

    <ng-template #showAll>
      <div class="badge-achieved-show-all">
        <span class="material-icons badge-achieved-show-all-icon">arrow_forward_ios</span>
      </div>
    </ng-template>
  </div>
</ng-container>
